import { CommandState } from '@thingslog/repositories';
import clsx from 'clsx';
import { t } from 'i18next';
import React, { FC } from 'react';

export const CommandStatusBox: FC<CommandStatusBoxProps> = ({
  commandState,
}: CommandStatusBoxProps) => {
  const commandStateColors: Record<CommandState | 'GENERIC', string> = {
    PENDING: 'border-yellow-600 text-yellow-600 bg-yellow-50',
    SENT: 'border-orange-600 text-orange-600 bg-orange-50',
    CANCELED: 'border-gray-600 text-gray-600 bg-gray-50',
    STATUS_OK: 'border-emerald-500 text-emerald-500 bg-emerald-50',
    STATUS_NOK: 'border-red-500 text-red-500 bg-red-50',
    UNKNOWN: 'border-purple-500 text-purple-500 bg-purple-50',
    TIMEOUT: 'border-red-200 text-red-200 bg-red-20',
    GENERIC: 'border-blue-500 text-blue-500 bg-blue-50',
  };

  const commandStateTranslations: Record<CommandState, string> = {
    PENDING: t('pending'),
    SENT: t('sent'),
    CANCELED: t('canceled'),
    STATUS_OK: t('status_ok'),
    STATUS_NOK: t('status_nok'),
    TIMEOUT: t('timeout'),
    UNKNOWN: t('unknown'),
  };

  return (
    <>
      <div
        className={clsx(
          'rounded border border-solid px-2 py-0.5 text-sm font-bold',
          commandStateColors[commandState || 'GENERIC']
        )}
      >
        {commandStateTranslations[commandState || ''].toUpperCase()}
      </div>
    </>
  );
};
interface CommandStatusBoxProps {
  commandState: CommandState | null;
}
